module.exports = __webpack_public_path__ + "img/enhancer2_src.456f3a65.webp";